var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    attrs: {
      "elementType": "section",
      "customClass": "ugc-tray-wrapper-edit ugc-tray-wrapper-edit--flex library"
    }
  }, [_c('CustomButton', {
    attrs: {
      "disabled": _vm.disableButton,
      "customClass": "ugc-tray-wrapper-button ugc-tray-wrapper-edit-apply-button",
      "type": "button"
    },
    on: {
      "click": _vm.setClickUGC
    }
  }, [_c('template', {
    slot: "right-icon"
  }, [_c('CustomText', {
    attrs: {
      "elementType": "span",
      "customClass": "text",
      "text": _vm.translations.trayWrapper[_vm.keyTranslation]
    }
  })], 1)], 2), _c('CustomButton', {
    attrs: {
      "disabled": _vm.disableButton,
      "type": "button",
      "customClass": "ugc-tray-wrapper-edit-container-button"
    },
    on: {
      "click": _vm.edit
    }
  }, [_c('template', {
    slot: "right-icon"
  }, [_c('CustomText', {
    attrs: {
      "elementType": "span",
      "customClass": "icon icon-camera"
    }
  }), _c('CustomText', {
    attrs: {
      "elementType": "span",
      "customClass": "text",
      "text": _vm.buttonText
    }
  })], 1)], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }